// extracted by mini-css-extract-plugin
export default {"cls1":"iHb0zo8evbNpWtZHjmzw","cls2":"UhKv0kqLdXWka9fFTGC_ iHb0zo8evbNpWtZHjmzw"};